import React from 'react';
import {
  ChatsWhatsappTableEl,
  ChatsWhatsappTableScroll,
} from './chatsWhatsappTable.styles';
import {
  LocacoesEmptyCell,
  LocacoesEmptyRow,
  LocacoesLoadingOverlay,
  LocacoesSpinner,
} from '../table/requestsLocacoesTable.styles';

const ChatsWhatsappColGroup = ({ chatTipo }) =>
  chatTipo === 'solicita' ? (
    <colgroup>
      <col style={{ width: 90 }} />
      <col style={{ width: 180 }} />
      <col />
      <col style={{ width: 210 }} />
      <col style={{ width: 56 }} />
      <col style={{ width: 160 }} />
      <col style={{ width: 132 }} />
    </colgroup>
  ) : (
    <colgroup>
      <col style={{ width: 170 }} />
      <col style={{ width: 140 }} />
      <col style={{ width: 180 }} />
      <col style={{ width: 100 }} />
      <col />
      <col style={{ width: 56 }} />
      <col style={{ width: 148 }} />
      <col style={{ width: 132 }} />
    </colgroup>
  );

const ChatsWhatsappTableView = ({ loading, lines, renderHeader, renderLine, chatTipo = 'coleta' }) => {
  const hasRows = Array.isArray(lines) && lines.length > 0;
  const columnCount = chatTipo === 'solicita' ? 7 : 8;

  return (
    <ChatsWhatsappTableScroll loading={loading} hasRows={hasRows} $chatTipo={chatTipo}>
      {loading && (
        <LocacoesLoadingOverlay aria-busy="true" aria-live="polite">
          <LocacoesSpinner />
        </LocacoesLoadingOverlay>
      )}
      <ChatsWhatsappTableEl>
        <ChatsWhatsappColGroup chatTipo={chatTipo} />
        <thead>{renderHeader()}</thead>
        <tbody>
          {hasRows
            ? lines.map((line, index) => renderLine(line, index))
            : !loading && (
                <LocacoesEmptyRow>
                  <LocacoesEmptyCell colSpan={columnCount}>Nenhum registro encontrado.</LocacoesEmptyCell>
                </LocacoesEmptyRow>
              )}
        </tbody>
      </ChatsWhatsappTableEl>
    </ChatsWhatsappTableScroll>
  );
};

export default ChatsWhatsappTableView;
